const priceProperties = {
  adultBuy1: 0,
  adultBuy2: 0,
  adultBuy3: 0,
  adultBuy4: 0,
  adultBuy5: 0,
  adultBuy6: 0,
  adultBuy7: 0,
  adultSell1: 0,
  adultSell2: 0,
  adultSell3: 0,
  adultSell4: 0,
  adultSell5: 0,
  adultSell6: 0,
  adultSell7: 0,
  childBuy1: 0,
  childBuy2: 0,
  childBuy3: 0,
  childBuy4: 0,
  childBuy5: 0,
  childBuy6: 0,
  childBuy7: 0,
  childSell1: 0,
  childSell2: 0,
  childSell3: 0,
  childSell4: 0,
  childSell5: 0,
  childSell6: 0,
  childSell7: 0,
  // currencyCodeBuy: "",
  // currencyCodeSell: "",
  currencyCode: "",
  dateFrom: "",
  dateTo: "",
  groupId: "",
  id: "",
  infantBuy1: 0,
  infantBuy2: 0,
  infantBuy3: 0,
  infantBuy4: 0,
  infantBuy5: 0,
  infantBuy6: 0,
  infantBuy7: 0,
  infantSell1: 0,
  infantSell2: 0,
  infantSell3: 0,
  infantSell4: 0,
  infantSell5: 0,
  infantSell6: 0,
  infantSell7: 0,
  maxStay: 0,
  minStay: 0,
  maxPax: 0,
  minPax: 0,
  ratePlan: "",
  remarks: "",
  rateTypeCode: "",
  serviceId: "",
  markup: 0,
  exception: false,
  marketPlace: false,
  businessModel: "BM1",
  supplierCommission: 0,
  api: true,
};
export const priceIsValid = (price) =>
  price.dateFrom != "" &&
  price.dateTo != "" &&
  price.currencyCodeBuy != "" &&
  price.currencyCodeSell != "";

const isNumberField = (field) =>
  (field.indexOf("Sell") != -1 && field != "currencyCodeSell") ||
  (field.indexOf("Buy") != -1 && field != "currencyCodeBuy") ||
  field == "markup";

const priceMapper = (item) =>
  Object.keys(priceProperties).reduce(
    (rateObj, prop) =>
      prop != "id"
        ? {
            [prop]:
              item[prop] != null
                ? isNumberField(prop)
                  ? Number(item[prop])
                  : item[prop]
                : priceProperties[prop],
            ...rateObj,
          }
        : rateObj,
    {}
  );
export { priceProperties, priceMapper };



// WEBPACK FOOTER //
// ./src/components/gt/suppliers/supplier-rates/edit/price-details/price-properties.js